import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const githubCoveragePlugin = createPlugin({
  id: 'github-coverage',
  routes: {
    root: rootRouteRef,
  },
});

export const GithubCoveragePage = githubCoveragePlugin.provide(
  createRoutableExtension({
    name: 'GithubCoveragePage',
    component: () =>
      import('./components/GithubCoveragePage').then(
        m => m.GithubCoveragePage,
      ),
    mountPoint: rootRouteRef,
  }),
);
